export default {
  // 薪酬
  salary: {
    salary: 'salary',
    payroll: 'payroll',
    salaryAccounting: 'salary accounting',
    socialSecurityFund: 'social security fund',
    personalIncomeTax: 'personal income tax',
    searchMonth: 'search month',
    payrollMonth: 'payroll month',
    payrollPlan: 'payroll plan',
    payrollNumber: 'payroll number',
    planName: 'plan name',
    InsuredCity: 'insured city',
    staffJoinNumber: 'staff and participants',
    staffName: 'staff names',
    mobilePhone: 'mobile phone',
    department: 'department',
    childrenEducation: 'children education',
    housingRent: 'housing rent',
    rentalloanInterest: 'rentalloan interest',
    supportOldman: 'support the elderly',
    continuingEducation: 'continuing education',
    otherDeductions: 'other deductions',
    seeDetails: 'view details',
    referenceStaff: 'reference staff',
    seePayrollInputPwd: 'Please enter your password for salary details.',
    tipsPwd: 'Tip: The password is the system login password.',
    cexiaoDel:
      'After cancellation, the payroll calculation results will be deleted from the payroll.',
    sureCexiao: 'Are you sure you want to cancel the calculated salary?',
    fabuSalaryResult: 'Whether to release the monthly compensation accounting results?',
    fabuSalaryResultInfo:
      'It cannot be changed after publication and is published to the payroll, through which employees can view the salary information.',
    sureDelSalary: 'Are you sure you want to delete payroll?',
    payrollCycle: 'payroll cycle',
    unpublished: 'unpublished',
    approval: 'in examination and approval',
    asbeenReleased: 'released',
    resigned: 'resigned',
    fullName: 'full name',
    realWages: 'net payroll',
    thisMonthTiaoxin: 'There is a salary adjustment this month.',
    wagesType1: 'fixed salary',
    wagesType2: 'floating wages',
    wagesType3: 'subsidies',
    wagesType4: 'check on work attendance',
    wagesType5: 'withhold and remit tax',
    wagesType6: 'personal tax accumulation information',
    wagesType7: 'individual income tax special additional deduction accumulated',
    wagesType8: 'wage statistics',
    sureTongbu: 'Are you sure you want to synchronize?',
    sureTongbuInfo1:
      'After confirmation, the current salary accounting will obtain the latest rules of background salary setting, which will resynchronize the attendance withholding and payment of fixed salary variable salary allowance and individual income tax, and change the existing data.',
    sureTongbuInfo2:
      'After confirmation, the current salary accounting will obtain the attendance, and the attendance content shall be resynchronized with salary and personal income tax and the existing data will be changed.',
    zancun: 'temporary storage',
    thisMonthLastDay: 'last day of the month',
    salaryHesuanMonth: 'salary accounting - month',
    downloadImportTemplate:
      'Please download the import template and improve the data according to the content of the template.',
    nameRepeatInputPhone:
      'If the name is the same, please fill in the phone number, otherwise it cannot be identified.',
    lizhi: 'dimission',
    tiaoxin: 'salary adjustment',
    heji: 'add up to',
    gonghao: 'work number',
    wagesType9: 'Attendance deductions',
    lastMonth: 'as of last month',
    zhiwei: 'position',
    addYuandong: 'add staff ',
    sureDelHesuan: 'Are you sure you want to delete payroll？',
    sureDelThisData: 'Are you sure you want to delete this data？',
    surePushHesuanResult: 'Whether to release the monthly compensation accounting results？',
    surePushHesuanResultInfo:
      'It cannot be changed after publication and is published to the payroll, through which employees can view the salary information.',
    sureCexiaoHesuanInfo:
      'The payroll calculation results will be deleted from the payroll after cancellation.',
    sureCexiaoHesuan: 'Are you sure you want to cancel the calculated salary?',
    dataIsEmpty: 'Data is empty.',
    pleaseAddYuangong: 'please add staff',
    salaryAccounting1: 'salary accounting',
    accountingZhouqi: 'accounting cycle ',
    tongbu1: 'keep abreast of the latest salary settings',
    tongbu2: 'synchronous attendance result',
    editJixinPer: 'revision of payroll staff',
    editMonthValue: "revision of last month's personal tax accumulation value",
    clickContent: 'click on the digital content to modify the value',
    delYuangong: 'delete staff',
    searchUsername: "search user's names",
    geshuiInfo:
      'The special individual income tax additional deduction fee shall be deducted every month. Each employee can only have one piece of data, which can be used to deduct the monthly expenses in salary accounting.',

    salaryNote:
      'automatically calculate the salary of employees to improve the efficiency of financial work',
    relatedPersonnel: 'associated personnel module',
    salarySet: 'salary settings',
    salaryManager: 'salary manager',
    associationType: 'association type',
    correlationModule: 'associated module',
    addCorrelationModule:
      'add more associated modules for custom modules required when adding items for fixed and floating salaries',
    departureDate: 'departure date',
    salaryAdjustmentDate: 'salary adjustment date',
    salaryAdjustmentRecord: 'salary adjustment record',
    correspondingContent: 'The project corresponds to the fixed salary content.',
    salaryBeforeSalaryAdjustment: 'salary before salary adjustment',
    salaryAfterSalaryAdjustment: 'salary after salary adjustment',
    associatedNameDate: 'associated name/date',
    correspondingTip:
      'Define the corresponding relationship between the system user and the associated module name;If the corresponding payroll period is needed, the date should be selected. If the date is empty, only the first item of data can be directly obtained.',
    tableName: 'table name',
    relatedName: 'associated name',
    relatedData: 'associated date',
    moduleDeleteTip: 'Are you sure you want to delete the associated module?',
    correspondingTip2:
      'After determining, please go to the corresponding adjustment in fixed salary and floating salary, otherwise the result of salary is wrong.',
    staff: 'staff',
    other: 'other',
    staffTble: 'staff table',
    resignationApplicationTable: 'resignation application table',
    applicationSalaryAdjustmentTable: 'application salary adjustment table',
    dataTable: 'data table',
    schemeAdmin: 'scheme manager',
    salaryApproval: 'salary approval',
    needApproval: 'need approval',
    noNeedApproval: 'no need for approval',
    salaryNumber: 'salary number',
    modifier: 'modifier',
    editTime: 'edit time',
    approvalTip:
      'After the approval process of salary setting, it is necessary to go through the approval process when submitting salary accounting. If the payroll is not set, it is not necessary to go through the approval process and then issue it.',
    approver: 'approver',
    ruleTip:
      'You can enter the background to set the compensation rules and select the program in the foreground compensation module for monthly compensation accounting.',
    approverLength5: 'The maximum number of approvers is 5.',
    name: 'name',
    payCycle: 'payroll cycle',
    correspondingAttendancePeriod: 'corresponding attendance period',
    tothisMonth: 'to this month',
    scopeOfApplication: 'scope of application',
    lastMonthlastDay: 'last day of the month',
    lastDay: 'last day',
    remark: 'remark',
    nextStep: 'next step',
    salaryStructureSetting: 'salary structure setting',
    attendanceCheck: 'attendance check',
    jinSubsidy: 'subsidies',
    lastMonth2: 'last month',
    scopeOfApplication_empty: 'Scope of application cannot be empty.',
    salaryStructureSettingTip:
      'According to the payroll requirements of the enterprise, carry out the salary item design. Please confirm that the relevant personnel module table has been set before setting the salary structure to meet the payroll calculation needs of the enterprise by adding a customized salary structure.',
    wagesTypeTip1:
      'When calculating the fixed salary, it is necessary to calculate the salary before and after the adjustment separately.',
    wagesTypeTip2: 'Variable pay is paid on the basis of performance.',
    wagesTypeTip3:
      'For the benefits provided by the enterprise to employees, please set the welfare rules in the tianjin subsidy, and the system will add the subsidy to the payroll calculation when calculating the salary.',
    attendanceCheckTip:
      'According to the attendance record of the employee, the salary shall be calculated according to certain rules. Please set the rules in the attendance salary. If no rules are set, the attendance will not be included in the salary calculation.',
    salaryDays: 'calculate the monthly standard salary days',
    attendanceScheduling: 'attendance scheduling',
    standardTime: 'standard time',
    personalSocialSecurity: 'personal social security',
    providentFund: 'provident fund',
    monthly: 'Every Month',
    monthly2: 'not pay social security provident fund if the departure before 2 ',
    personalTax: 'personal tax',
    accumulatedRevenue: 'accumulated revenue',
    cumulativeDeductionExpense: 'cumulative deduction expense',
    accumulatedSpecialDeduction: 'accumulated special deduction',
    cumulativeSpecialAdditionalDeduction: 'cumulative special additional deduction',
    cumulativeOtherDeductions: 'cumulative other deductions',
    cumulativeTaxPayable: 'cumulative tax payable',
    wageItem: 'salary Items',
    dataSource: 'data source',
    keepDecimalPlaces: 'preserved decimal place',
    decimals: 'decimals',
    accuracy: 'accuracy',
    beforeTaxAfterTax: 'before tax/after tax',
    formula: 'formula',
    subsidyProject: 'subsidy project',
    inputLength25: 'Please enter your name within 25 words.',
    round: 'round',
    tailRemoval: 'tail removal',
    enterOne: 'enter one',
    addBeforeTax: 'Pre-tax add items',
    preTaxDeduction: 'Pre-tax reduction items',
    addAfterTax: 'After-tax add items',
    afterTaxDeduction: 'After-tax reduction items',
    deleteItem: 'Are you sure you want to delete this item?',
    empty: 'cannot be null',
    withholdinge_error: 'wrong form of withholding',
    attendanceAndSalary: 'attendance and payroll',
    numberOfSubsidies: 'number of subsidies',
    attendanceCheckHandleTip:
      'For the enterprise to leave for overtime and absenteeism work attendance set rules, can be set according to the situation of the enterprise.',
    leaveDeductionRules: 'leave deduction rules',
    leaveTypeTip:
      'corresponding to the leave type associated with the approval form in the attendance module',
    eductionRules: 'abnormal attendance deduction rules',
    eductionRulesTip: 'attendance status card absence late absence early refund deduction rules',
    missingCardNumber: 'missing card number',
    late: 'late',
    eaveEarly: 'leave early',
    absenteeism: 'absenteeism',
    overtimePayRules: 'overtime pay rules',
    overtimeWorkTip:
      'If the employees work overtime, the enterprise will give them extra compensation for overtime work, which corresponds to overtime work in the attendance module.',
    compensate: 'full attendance award and night shift compensation',
    fullAttendance: 'full attendance award',
    eveningShift: 'night shift',
    calculationItem: 'calculation item',
    calculationItemTip:
      'Please select the checking-in salary, corresponding to the fixed salary and variable salary, plus the pre-tax item.',
    deductionRatio: 'deduction ratio',
    numberTip: 'Please enter a positive number and reserve a maximum of 2 decimal places.',
    noDeductionDuration: 'time without deduction',
    durationMonth: 'duration/month',
    calculationMethod: 'calculation method',
    deductionByTimes: 'deduction by times',
    notRange: 'The replacement card is not included in the statistics.',
    lateMinuteTip: 'Deduction for every 1 minute late.',
    lateTimesTip: 'Every time you are late, you will be charged.',
    unit: 'unit',
    times: 'times',
    personalization: 'personalization',
    accumulatedLateEveryMonth: 'accumulated late every month',
    lateTime: 'late time',
    lateTime2: 'Times，And the single time of being late is',
    lateTime3: 'Times，And the cumulative time of being late is',
    eaveEarlyMinuteTip: 'No money will be deducted within minutes.',
    eaveEarlyTimesTip: 'Every 1 minute left early will be deducted.',
    absenteeismPress: 'absenteeism by',
    doubleSalaryPenalty: 'multiple pay penalty',
    pleaseEnterNumber: 'Please enter Numbers.',
    pleaseEnterInteger: 'Please enter an integer',
    fixedAmount: 'fixed amount',
    yuan: 'yuan',
    compensationProportion: 'compensation proportion',
    noFullAttendanceAwardWillBeIssued:
      'If one of the following conditions is met, the full attendance award will not be issued.',
    clockOutTimeExceeds: 'Clock out time exceeds.',
    nightShiftAward: 'night shift award',
    nightShiftAsChild: 'The hour is the night shift.',
    jinSubsidyTip:
      'Monthly subsidy shall be paid. Please specify the project name in the compensation structure, such as high-temperature subsidy, transportation subsidy, car subsidy, meal subsidy, etc. In the payment method, the daily subsidy shall be the actual attendance attendance days.',
    monthlySubsidies: 'monthly subsidies',
    subsidyByDay: 'subsidy by aay',
    jinSubsidyRules: 'Subsidy rules',
    deductionRules_error: 'Leave deduction rule format is wrong.',
    setInsuredBaseAndProportion: 'set insured base and proportion',
    setInsuredAmountOnly: 'set insured amount only',
    payer: 'payer',
    setInsuredTip:
      'After open, set ginseng to protect base and scale will be disabled, calculate according to this rule social security and accumulation fund.',
    associationDataTable: 'association data table',
    associatedName: 'associated name',
    companySocialSecurity: 'related company social security amount',
    personalSocialSecurity2: 'association of individual social security amount',
    companyAccumulationFund: 'the amount of accumulation fund of affiliated companies',
    personalAccumulationFund: 'related individual accumulation fund amount',
    paymentCity: 'payment city',
    paymentBase: 'payment base',
    schemeContent: 'scheme content',
    schemeContentTip:
      'Description: the social security provident fund will obtain the initial value according to the provincial area, after the change needs to be maintained manually.',
    socialSecurity: 'social security',
    projectName: 'project name',
    baseLowerLimit: 'base lower limit',
    baseUpperLimit: 'base upper limit',
    companyPaymentRatio: 'company payment ratio',
    individualPaymentRatio: 'individual payment ratio',
    fixedValue: 'fixed value',
    EndowmentInsurance: 'endowment insurance',
    medicalInsurance: 'medical insurance',
    unemploymentInsurance: 'unemployment Insurance',
    workInjuryInsurance: 'employment injury insurance',
    maternityInsurance: 'maternity insurance',
    definitePreservation: 'Sure to save.',
    nameRepetition: 'Name cannot be repeated.',
    managerTip:
      'You can enter the background to set compensation rules and choose the compensation module in the front desk for monthly compensation accounting.',
    schemeAdminTip:
      'You can enter the background to set social security provident fund rules and in front of the associated staff.',
    commonOperators: 'common operators',
    selectFormula: 'Please select the formula.',
    setRule: 'set up rules',
    missingCard: 'missing card',
    nightShiftAward_error: 'Night shift award format is wrong.',
    clockOutTime_error: 'Only 1-8 hours can be entered after hours.',
    fullAttendance_error: 'Full attendance award format error',
    compensationProportion_error: 'Compensation for proportion formatting error',
    multiple_error: 'multiple format error',
    error: 'formal error ',
    amountDeduction_error: 'The deduction amount is wrongly formatted',
    option1: 'deduct the money by yuan/times',
    option2: 'Deductions are made in a fixed amount.',
    option3: 'deduct the money according to the length of absence',
    option4: 'deduct the money according to the length of your late time',
    option5: 'deduct the money according to the times of lateness',
    option6: 'step deduction for each tardiness',
    option7: 'accumulated tardiness time by month',
    option8: 'monthly cumulative late times ladder deduction',
    option9: 'deduct the money according to the time of leaving early',
    option10: 'according to a single morning leave time ladder deduction',
    option11: 'step deduction for leaving early by month',
    option12: 'according to the monthly cumulative number of early withdrawal step deduction',
    option13: 'compensation in fixed amount',
    option14: 'compensation in proportion to salary',
    option15: 'yuan/time',
    option16: 'time',

    overlapOrDiscontinuity: 'No overlap or discontinuity is allowed',
    inductionDate: 'entry date',
    pleaseSelectFangan: 'please select salary scheme',
    pleaseSelectYuefen: 'please select salary month',
    option17: 'Yuan / min',
    option18: 'Deduct according to the number of early leave',
    place: 'place',
    virtualValue: 'Please enter a valid value',
    deductions: 'time deduction',
    holidaysRequirePay: 'holidays need to be paid',
    HD: 'hours/day',
    holiday_error: 'Holiday salary format error',
    noJixinPlan:
      'There is no salary scheme in the current company. Please go to the background to create the scheme.',
    // 20201224
    minuteslatesingletime: 'Minutes late for a single time',
    cumulativeminuteslate: 'Accumulated minutes late',
    // 20210305
    pageaddmember: 'Please add personnel in the [Salary Administrator] tab first'
  }
}
